module.exports = __webpack_public_path__ + "img/明细账.04dc30bf.png";